import { Button } from 'reactstrap';
import Scroll from 'react-scroll';
import RoundButton from './RoundButton';
var ScrollButton = Scroll.ScrollLink(Button);
var RoundScrollButton = Scroll.ScrollLink(RoundButton);
ScrollButton.defaultProps = RoundScrollButton.defaultProps = {
  spy: true,
  smooth: true,
  offset: -190,
  duration: 500,
  delay: 50
};
export { RoundScrollButton };
export default ScrollButton;